import { defineStore } from 'pinia'
import { ref } from 'vue'
import ApplicationEnvironment from 'src/models/application-environment/ApplicationEnvironment'

export const useApplicationEnvironmentStore = defineStore(
  'application-environment',
  () => {
    const applicationEnvironment = ref<ApplicationEnvironment>()

    return { applicationEnvironment }
  },
)
